import { useEffect } from 'react'

import { getStoredCurrentStep } from 'components/member_onboarding_v2/navigationUtils'
import { useOnboarding } from 'components/member_onboarding_v2/OnboardingContext'

/**
 * Clears plan filters from the URL when the user navigates to any page other
 * than the medical plans page, medical plans detail page, or the medical plan
 * comparison page.
 */
export function useClearPlanFilters () {
  const { enrollmentEventId } = useOnboarding()

  useEffect(() => {
    return () => {
      const step = getStoredCurrentStep(enrollmentEventId)

      if (!step?.startsWith('medical_plan')) {
        const url = new URL(window.location.href)

        url.searchParams.delete('metal_tiers')
        url.searchParams.delete('carriers')
        url.searchParams.delete('plan_types')

        window.history.replaceState({}, '', url.toString())
      }
    }
  }, [])
}
